import { render, staticRenderFns } from "./form-customer.vue?vue&type=template&id=713f4203&scoped=true"
import script from "./form-customer.vue?vue&type=script&lang=js"
export * from "./form-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713f4203",
  null
  
)

export default component.exports